//declare function require(name: string): any;
//var jsUtilities = require('../../js/jsUtilities');

import common = require("../common");
import context = require("../modules/context");


class PageService {

    validateResponseDataGlobal(data?: common.IResponseDataGlobal, onRefreshApply?: () => void) {
        if (!data || !data.outdatedContent)
            return true;

        const t = data.outdatedContent.CustomRefreshTitleHtml;
        const m = data.outdatedContent.CustomRefreshMessageHtml;
        const p = context.components.getPage();
        p.showRefreshPopup(() => {

            if (onRefreshApply)
                onRefreshApply();
        }, t, m);
        return false;
    }
}

export = PageService;